"use client"

import { User, XMark } from "@medusajs/icons"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import type { PublicStorefrontSettings, ResolvedMenuItem } from "../../types"
import { useGlobalAside } from "../../context/global-aside-context"
import Aside from "../aside"
import styles from "../aside/aside.module.css"

function MenuItemLink({ item, onNavigate }: { item: ResolvedMenuItem; onNavigate(): void }) {
  const sharedProps = {
    className: styles.menuLink,
    target: item.new_tab ? "_blank" : undefined,
    rel: item.external || item.new_tab ? "noopener noreferrer" : undefined,
    onClick: onNavigate,
  }

  if (item.external) {
    return (
      <a href={item.href} {...sharedProps}>
        {item.label}
      </a>
    )
  }

  return (
    <LocalizedClientLink href={item.href} {...sharedProps}>
      {item.label}
    </LocalizedClientLink>
  )
}

export default function MobileNavigationAside({ settings }: { settings: PublicStorefrontSettings }) {
  const { close } = useGlobalAside()
  const closeMenu = () => close("mobile")

  return (
    <Aside kind="mobile" label="Menü" side="left">
      <header className={styles.panelHeader}>
        <h2 className={styles.panelTitle}>Menü</h2>
        <button type="button" className={styles.closeButton} onClick={closeMenu} aria-label="Menüyü kapat">
          <XMark aria-hidden="true" />
        </button>
      </header>
      <div className={styles.panelBody}>
        <nav aria-label="Mobil menü">
          <ul className={styles.menuList}>
            {settings.header.items.map((item) => (
              <li key={item.id}><MenuItemLink item={item} onNavigate={closeMenu} /></li>
            ))}
          </ul>
          <LocalizedClientLink className={styles.accountLink} href="/account" onClick={closeMenu}>
            <span>Hesabım</span>
            <User aria-hidden="true" />
          </LocalizedClientLink>
        </nav>
      </div>
    </Aside>
  )
}
